import React, { useContext } from "react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import IReview from "models/Reviews";
import { useNavigate } from "react-router-dom";
import { findPermission } from "utilities/findPermission";
import { AuthContext } from "navigation/AuthProvider";

export interface ReviewCardProps {
  review: IReview;
  onEvaluate?: (id: string) => void;
}

const ReviewCard = ({ review }: ReviewCardProps) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const canAuthorReview = ["Manager"];
  const canAuthorReviewPermission = findPermission(canAuthorReview,user.user.roles[0].name);

  return (
    <Box mt={3}>
      <Paper elevation={3} sx={{ backgroundColor: "#F6F7FA" }}>
        <Box sx={{ display: "flex", flexDirection: "column", padding: "14px" }}>
          <Typography variant="h6" fontSize="18px" fontWeight={800} mb={1}>
            Manager Review Form
          </Typography>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell>Who authors this form:</TableCell>
                  <TableCell sx={{ display: "flex", alignItems: "center" }}>
                    {review.user?.line_manager?.profile_image && (
                      <Avatar src={review.user.line_manager.profile_image} alt="Francis Hanfried" />
                    )}
                    <Typography
                      ml={2}
                    >{`${review.user?.line_manager?.first_name} ${review.user?.line_manager?.last_name}`}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Who signs off on this form:</TableCell>
                  <TableCell sx={{ display: "flex", alignItems: "center" }}>
                    {review.user?.profile_image && (
                      <Avatar src={review.user.profile_image} alt="Francis Hanfried" />
                    )}
                    <Typography
                      ml={2}
                    >{`${review.user?.first_name} ${review.user?.last_name}`}</Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Due Date (authors):</TableCell>
                  <TableCell>
                    <Typography>{review.author_dueDate}</Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box display="flex" alignItems="center" mt={1}>
            <Typography>
              Visible to the subject (when all authors/signers have completed their actions)
            </Typography>
            {review.status === "Completed" && <VerifiedIcon sx={{ color: "green", ml: 1 }} />}
          </Box>
          <Box display="flex" alignItems="center" justifyContent="end" mt={2} gap={1}>
            <Button variant="contained" color="primary" sx={{ width: "20%" }}>
              View
            </Button>
            <Button
              variant="outlined"
              color="primary"
              sx={{ width: "20%" }}
              onClick={() => navigate("/evaluation")}
              disabled = {!canAuthorReviewPermission}
            >
              Author
            </Button>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ReviewCard;
